import { BuildFontString } from "../utils/BuildFontString";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumElementDrawStates,
  kDropDownButtonArrow,
  kDropDownRightMargin,
  kfontIconNameRegularXSmall,
  kTriangleHeight
} from "../constants";
import { QStdButton } from "./QStdButton";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { Globals } from "./Globals.js";
import { MeasureText } from "../utils/MeasureText.js";
import { SetCtxFont } from "../utils/SetCtxFont.js";

export class QPadlessButton extends QStdButton {
  constructor() {
    super();
    this.fFontString = null;
  }

  DrawAdornment(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");

    ctx.fillStyle = this.fEnabled ? this.fFontColor : Globals._themeMode.text.disabled;

    var h = this.GetHeight();
    var w = this.GetWidth();

    var yPos = this.fVertOffset + h - kTriangleHeight - 2;

    var xPos =
      this.fHorzOffset +
      this.GetMarginH() +
      MeasureText(this.GetTruncLabel(), this.GetFontString()) +
      kDropDownRightMargin;

    SetCtxFont(ctx, kfontIconNameRegularXSmall);
    ctx.fillText(kDropDownButtonArrow, xPos, yPos);
  }

  SetCTXFillStyle(ctx) {
    var buttonFillStyle = "#f3dabb";
    var buttonStrokeStyle = this.fBorderColor;
    var txtFillStyle = this.fFontColor;
    var etchIt = false;
    var grd1 = null;

    var sx1 = this.fHorzOffset + 1;
    var sy1 = this.fVertOffset + 5;
    var ex1 = this.fHorzOffset + 12;
    var ey1 = this.fVertOffset + this.fHeight - 5;
    // Draw the button (interior and border)
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        buttonFillStyle = this.fFillColor;
        break;
      case enumElementDrawStates.Hover:
        break;
      case enumElementDrawStates.MouseDown:
        //etchIt = true;
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = Globals._themeMode.text.disabled;
        buttonStrokeStyle = txtFillStyle;
        break;
    }

    ctx.fillStyle = buttonFillStyle;
    ctx.strokeStyle = buttonStrokeStyle;

    return grd1;
  }

  GetFontString() {
    var fontInfo = this.fFontString;
    if (!this.fFontString)
      fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    return fontInfo;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var txtFillStyle = this.fFontColor;
    var gradient = this.SetCTXFillStyle(ctx);

    var thickness = 1;
    ctx.lineWidth = thickness;
    var adj = ThicknessAdjuster(thickness);
    var sx = this.fHorzOffset + adj;
    var sy = this.fVertOffset + adj;
    var sw = this.fWidth;
    var sh = this.fHeight;

    if (this.fClippedRegion) {
      if (gradient) ctx.fillStyle = gradient;
      ctx.fill(this.fClippedRegion);
    } else {
      ctx.fillRect(sx, sy, sw, sh);
      if (gradient) {
        ctx.fillStyle = gradient;
        ctx.fillRect(sx, sy, sw, sh);
      }
    }

    ctx.globalAlpha = 1.0;
    // Now Draw the text in the button
    if (this.fCurDrawState === enumElementDrawStates.Disabled) {
      txtFillStyle = Globals._themeMode.text.disabled;
      ctx.strokeStyle = txtFillStyle;
    }
    ctx.fillStyle = txtFillStyle;
    var fontInfo = this.GetFontString();

    //ctx.font= BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);

    var txt = this.GetTruncLabel(); // fTruncLabel;
    var alignment = this.GetHAlignment();

    var txtHOffset = this.GetMarginH();
    if (alignment == "center")
      txtHOffset = Div2Floor(this.fWidth); // Math.floor(this.fWidth/2);
    else if (alignment == "right") txtHOffset = this.fWidth - this.GetMarginH();
    var txtVOffset = Div2Floor(this.fHeight) + 1; // Math.floor(this.fHeight/2);
    ctx.textAlign = alignment;
    ctx.textBaseline = "middle";

    ctx.fillText(txt, this.fHorzOffset + txtHOffset, this.fVertOffset + txtVOffset);

    if (this.fDoDropdown) this.DrawAdornment(drawBuffer);
    ctx.globalAlpha = 1.0;
  }

  GetHAlignment() {
    return "left";
  }

  GetMaxLabelWidth() {
    return this.GetWidth() - kDropDownRightMargin * 2;
  }

  DoCalculateMinWidth() {
    var ctx = this.fMeasureBuffer.getContext("2d");

    var fontInfo = this.fFontString
      ? this.fFontString
      : BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);
    var txt = this.fLabel;

    var txtDim = ctx.measureText(txt);
    var txtWidth = Math.ceil(txtDim.width);

    txtWidth = txtWidth + this.GetMarginH() * 2;
    if (this.fDoDropdown) txtWidth += 20;
    return txtWidth;
  }

  GetCursor() {
    return "pointer";
  }

  GetParentPanel() {
    return this.fParentPanel;
  }
}
